export enum GuestSegmentTypes {
  POTENTIAL = 'Potential',
  NEW = 'New',
  OCCASIONAL = 'Occasional',
  REGULAR = 'Regular',
  LOST = 'Lost',
}

export enum GuestSegmentDescription {
  NEW = 'Guests who just started placing orders.',
  OCCASIONAL = 'Guests who order occasionally.',
  REGULAR = 'Guests who order most frequently.',
  LOST = 'Guests who haven’t ordered for a long time.',
  POTENTIAL = 'Guests who signed up but haven’t ordered yet',
}

export enum GuestSegmentDescription2 {
  NEW = 'Customers who just started placing orders.',
  OCCASIONAL = 'Customers who order occasionally.',
  REGULAR = 'Customers who order most frequently.',
  LOST = 'Customers who haven’t ordered for a long time.',
  POTENTIAL = 'Guests who signed up but haven’t ordered yet',
}

export enum GuestSegmentDurationTypes {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  THREE_MONTH = '3 month',
  SIX_MONTH = '6 month',
  NINE_MONTH = '9 month',
  YEAR = 'year',
}

export enum GuestSpendTypes {
  ECONOMY = 'economy',
  STANDARD = 'standard ',
  PREMIUM = 'premium',
}

export enum GuestSpendDescriptions {
  ECONOMY = 'Range for budget-conscious customers.',
  STANDARD = 'Range for your regular, everyday customers.',
  PREMIUM = 'Range for your high-value guests with a higher spending bracket.',
}

export interface CustomerOrderAndSegment {
  customerId: string;
  customerCreatedAt: Date | null;
  totalOrders: number;
  lastOrderDate: Date | null;
  secondLastOrderDate: Date | null;
  guestSegmentId: number | null;
  currentSegment: GuestSegmentTypes;
}

export interface CustomerSegmentUpdate {
  guestSegmentId?: number | null;
  customerId: string;
  segment: GuestSegmentTypes;
  restaurantId: number;
}
